<template>
  <div>
    <c-tab
      ref="patrolTab"
      type="horizon"
      :inlineLabel="true"
      :dense="true"
      :tabItems="tabItems"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :key="tab.key"
          :popupParam.sync="popupParam"
          :patrol.sync="patrol"
          :eventScroll.sync="eventScroll"
          :resultItems.sync="resultItems"
          :colorItemse.sync="colorItems"
          :child.sync="child"
          @closePopup="closePopup"
          @transInfo="transInfo"
          @research="research"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import mixinCommon from '@/js/mixin-page-common'
export default {
  name: 'patrol-detail',
  mixins: [mixinCommon],
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        saiPatrolId: '',
      }),
    },
    eventScroll: {
      type: Object,
      default(){
        return {
          position: null,
          direction: null,
          save: null,
          isSave: false,
        }
      },
    },
    contentHeight: null,
  },
  data() {
    return {
      patrol: {
        saiPatrolId: '',  // 순회점검 일련번호
        plantCd: '',  // 사업장 코드
        patrolName: '',  // 순회명
        patrolStartDate: '',  // 순회시작일
        patrolEndDate: '',  // 순회종료일
        deptCd: '',  // 점검부서 코드
        deptName: '',  // 점검부서
        patrolResultCd: null,  // 특이사항
        patrolResultSummary: '',  // 순회결과요약
        patrolStepCd: null,  // 진행상태
        checkUserId: '',
        regUserId: '',  //
        places: [],
        deletePlaces: [],
        imprs: [],
      },
      tab: '',
      tabItems: [],
      child: {
        tab: '',
        tabItems: [],
      },
      resultItems: [],
      colorItems: [],
      editable: true,
      detailUrl: '',
    };
  },
  computed: {
    mobileSave() {
      return {
        bol: this.editable && this.patrol.patrolStepCd !== 'PS00000010',
        uid: uid(),
      }
    },
    tabHeight() {
      return String(this.contentHeight - 36) + 'px';
    },
    // tab() {
    //   return this.patrol.patrolStepCd === 'PS00000005' ? 'place' : 'plan'
    // },
    // tabItems() {
    //   let defaultItem = [
    //     { key: uid(), name: 'plan', icon: 'edit', label: '점검계획', component: () => import(`${'./patrolPlanInfo.vue'}`) },
    //   ];
    //   if (this.patrol.patrolStepCd === 'PS00000005' || this.patrol.patrolStepCd === 'PS00000010') {
    //     defaultItem = this.$_.concat(defaultItem, [
    //       { key: uid(), name: 'place', icon: 'edit', label: '점검장소별 결과', component: () => import(`${'./patrolPlace.vue'}`) },
    //       { key: uid(), name: 'impr', icon: 'auto_fix_normal', label: '개선 현황', component: () => import(`${'./patrolImprove.vue'}`) },
    //     ]);
    //   }
    //   return defaultItem;
    // },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.sai.patrol.get.url;

      
      this.$comm.getComboItems('PATROL_LINE_RESULT_CD').then(_result => {
        this.resultItems = _result
      });

      this.$comm.getStepItems('IBM_STEP_CD').then(__result => {
        this.colorItems = __result
      });
      // code setting
      // list setting
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.saiPatrolId) {
        this.$http.url = this.$format(this.detailUrl, this.popupParam.saiPatrolId);
        this.$http.type = 'GET';
        this.$http.param = this.searchParam;
        this.$http.request((_result) => {
          this.$_.extend(this.patrol, _result.data);
          this.setTab();
        },);
      } else {
        this.patrol.checkUserId = this.$store.getters.user.userId;
        this.patrol.patrolStartDate = this.$comm.getToday();
        this.patrol.patrolName = this.$comm.getToday() + ' 순회점검';
        this.patrol.patrolStepCd = 'PS00000001'
        this.$http.url = selectConfig.sai.patrol.resultItem.place.line.url;
        this.$http.type = 'GET';
        this.$http.param = {
          plantCd: this.$store.getters.user.plantCd,
          itemFlag: 'Y',
          useFlag: 'Y',
        };
        this.$http.request((_result) => {
          this.$_.forEach(_result.data, _item => {

            if (_item.lines)
            this.patrol.places.push({
              saiPatrolPlaceId: uid(),  // 순회점검 결과 장소 일련번호
              saiPatrolId: this.popupParam.saiPatrolId,  // 순회점검 일련번호
              placeId: _item.placeId,  // 장소번호
              placeName: _item.placeName,  // 장소
              deptCd: '',  // 점검부서 코드
              deptName: '',  // 점검부서
              userId: '',  // 점검부서 코드
              userName: '',  // 점검부서
              patrolPlaceStepCd: 'PPS0000001',  // 순회점검 장소 진행상태
              lines: _item.lines,
              regUserId: this.$store.getters.user.userId,
              editFlag: 'C',
            })
          })
        },);
        this.setTab();
      }
    },
    setTab() {
      // 순회점검 tab 설정
      this.tab = this.patrol.patrolStepCd === 'PS00000005' ? 'place' : 'plan'
      let tabItem = [
        { key: uid(), name: 'plan', icon: 'edit', label: '점검계획', component: () => import(`${'./patrolPlanInfo.vue'}`) },
      ];
      if (this.patrol.patrolStepCd === 'PS00000005' || this.patrol.patrolStepCd === 'PS00000010') {
        tabItem = this.$_.concat(tabItem, [
          { key: uid(), name: 'place', icon: 'edit', label: '점검장소별 결과', component: () => import(`${'./patrolPlace.vue'}`) },
          { key: uid(), name: 'impr', icon: 'auto_fix_normal', label: '개선 현황', component: () => import(`${'./patrolImprove.vue'}`) },
        ]);
      }
      this.tabItems = tabItem;

      // 순회점검 장소별 결과 tab 설정
      let childTabItems = [];
      if (this.patrol.places && this.patrol.places.length > 0) {
        this.child.tab = this.patrol.places[0].placeId
        this.$_.forEach(this.patrol.places, place => {
          if (!place.patrolDate) {
            place.patrolDate = this.patrol.patrolStartDate
          } 
          childTabItems.push({
            // tab info
            key: uid(),
            name: place.placeId, icon: 'place', label: place.placeName,
            component: () => import(`${'./patrolPlaceResult.vue'}`),
            // place info
            place: place,
          })
        })
      }
      this.child.tabItems = childTabItems;
    },
    closePopup(data) {
      this.$emit('closePopup', data);  
    },
    transInfo(data) {
      this.$set(this.popupParam, 'saiPatrolId', data)
      this.getDetail();
    },
    research() {
      this.$set(this.popupParam, 'research', uid());
    },
  }
};
</script>
